import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Channel } from 'phoenix';
import type { Observable } from 'rxjs';

import { APP_CONFIG } from '@core/common-legacy';
import type { TellentAdminAppConfig, OrganizationChannel } from '@core/tellent-types';
import { WebsocketService } from '@core/websocket-legacy';

import { TellentCurrentUserSelectors } from './store/tellent-current-user.store';

@Injectable({
  providedIn: 'root',
})
export class TellentSocketService extends WebsocketService {
  public store = inject(Store);
  public config = inject<TellentAdminAppConfig>(APP_CONFIG);
  public currentUser = this.store.selectSignal(TellentCurrentUserSelectors.data);

  public connect() {
    const currentUser = this.currentUser();

    if (currentUser) {
      return super.socketConnect(this.config.tellentApiWsUrl, {
        params: { socket_token: currentUser.socketToken },
      });
    }

    throw new Error('TellentCurrentUserSelectors.currentOrganizationMembershipSelector empty');
  }

  public subscribeToChannel<T extends `intelligence:assistant:${string}`>(
    topic: T,
  ): Observable<Channel>;
  public subscribeToChannel<T extends `org:${string}`>(topic: T): Observable<OrganizationChannel>;
  public subscribeToChannel(topic: string): Observable<Channel> {
    return super.subscribeToChannel(topic);
  }
}
